// Map of label indices to label names
export const ID_TO_LABEL = {
    1: 'B-STEREO',
    2: 'I-STEREO',
    3: 'B-GEN',
    4: 'I-GEN',
    5: 'B-UNFAIR',
    6: 'I-UNFAIR',
    7: 'B-EXCL',
    8: 'I-EXCL',
    9: 'B-FRAME',
    10: 'I-FRAME',
    11: 'B-ASSUMP',
    12: 'I-ASSUMP',
};

export const BIAS_CATEGORIES: Record<string, string> = {
    STEREO: 'Stereotype',
    GEN: 'Generalization',
    UNFAIR: 'Unfairness',
    EXCL: 'Exclusion',
    FRAME: 'Framing',
    ASSUMP: 'Assumption',
};

export const BIAS_HIGHLIGHT_COLORS: Record<string, string> = {
    STEREO: 'bg-red-200 hover:bg-red-300',
    GEN: 'bg-blue-200 hover:bg-blue-300',
    UNFAIR: 'bg-green-200 hover:bg-green-300',
    EXCL: 'bg-yellow-200 hover:bg-yellow-300',
    FRAME: 'bg-purple-200 hover:bg-purple-300',
    ASSUMP: 'bg-indigo-200 hover:bg-indigo-300',
};

export const BIAS_REASONS: Record<string, string> = {
    STEREO: 'Stereotypical association',
    GEN: 'Generalization based on a group',
    UNFAIR: 'Unfair characterization',
    EXCL: 'Exclusion of a group',
    FRAME: 'Framing a group in a negative light',
    ASSUMP: 'Assumption based on a group',
};

export const BIAS_TOKEN_COLORS: Record<string, string> = {
    'B-STEREO': 'bg-red-200 border-red-400 dark:bg-red-700 dark:border-red-500',
    'I-STEREO': 'bg-red-100 border-red-300 dark:bg-red-600 dark:border-red-400',
    'B-GEN':
        'bg-blue-200 border-blue-400 dark:bg-blue-700 dark:border-blue-500',
    'I-GEN':
        'bg-blue-100 border-blue-300 dark:bg-blue-600 dark:border-blue-400',
    'B-UNFAIR':
        'bg-green-200 border-green-400 dark:bg-green-700 dark:border-green-500',
    'I-UNFAIR':
        'bg-green-100 border-green-300 dark:bg-green-600 dark:border-green-400',
    'B-EXCL':
        'bg-yellow-200 border-yellow-400 dark:bg-yellow-700 dark:border-yellow-500',
    'I-EXCL':
        'bg-yellow-100 border-yellow-300 dark:bg-yellow-600 dark:border-yellow-400',
    'B-FRAME':
        'bg-purple-200 border-purple-400 dark:bg-purple-700 dark:border-purple-500',
    'I-FRAME':
        'bg-purple-100 border-purple-300 dark:bg-purple-600 dark:border-purple-400',
    'B-ASSUMP':
        'bg-indigo-200 border-indigo-400 dark:bg-indigo-700 dark:border-indigo-500',
    'I-ASSUMP':
        'bg-indigo-100 border-indigo-300 dark:bg-indigo-600 dark:border-indigo-400',
    O: 'bg-gray-100 border-gray-300 dark:bg-gray-600 dark:border-gray-400',
};

export const BIAS_TOKEN_LABELS: Record<string, string> = {
    'B-STEREO': 'Beginning of Stereotype',
    'I-STEREO': 'Inside Stereotype',
    'B-GEN': 'Beginning of Generalization',
    'I-GEN': 'Inside Generalization',
    'B-UNFAIR': 'Beginning of Unfairness',
    'I-UNFAIR': 'Inside Unfairness',
    'B-EXCL': 'Beginning of Exclusion',
    'I-EXCL': 'Inside Exclusion',
    'B-FRAME': 'Beginning of Framing',
    'I-FRAME': 'Inside Framing',
    'B-ASSUMP': 'Beginning of Assumption',
    'I-ASSUMP': 'Inside Assumption',
    O: 'Not Biased',
};

// Label priority order - 'B-' labels take precedence over 'I-' labels
export const BIAS_LABEL_PRIORITY: string[] = [
    'B-STEREO',
    'B-GEN',
    'B-UNFAIR',
    'B-EXCL',
    'B-FRAME',
    'B-ASSUMP',
    'I-STEREO',
    'I-GEN',
    'I-UNFAIR',
    'I-EXCL',
    'I-FRAME',
    'I-ASSUMP',
    'O',
];

export const BIAS_FILTERS = [
    {
        label: 'Show All',
        value: 'ALL',
    },
    {
        label: 'Stereotype',
        value: 'STEREO',
    },
    {
        label: 'Generalization',
        value: 'GEN',
    },
    {
        label: 'Unfairness',
        value: 'UNFAIR',
    },
    {
        label: 'Exclusion',
        value: 'EXCL',
    },
    {
        label: 'Framing',
        value: 'FRAME',
    },
    {
        label: 'Assumption',
        value: 'ASSUMP',
    },
];

export const AI_MODELS = [
    // {
    //     type: 'model',
    //     name: 'text-embedding-3-small',
    //     friendly_name: 'OpenAI Text Embedding 3 (small)',
    //     model_family: 'OpenAI',
    //     publisher: 'OpenAI',
    // },
    // {
    //     type: 'model',
    //     name: 'text-embedding-3-large',
    //     friendly_name: 'OpenAI Text Embedding 3 (large)',
    //     model_family: 'OpenAI',
    //     publisher: 'OpenAI',
    // },
    {
        type: 'model',
        name: 'gpt-4o-mini',
        friendly_name: 'OpenAI GPT-4o mini',
        model_family: 'OpenAI',
        publisher: 'OpenAI',
    },
    {
        type: 'model',
        name: 'gpt-4o',
        friendly_name: 'OpenAI GPT-4o',
        model_family: 'OpenAI',
        publisher: 'OpenAI',
    },
    {
        type: 'model',
        name: 'o3-mini',
        friendly_name: 'OpenAI o3-mini',
        model_family: 'OpenAI',
        publisher: 'OpenAI',
    },
    {
        type: 'model',
        name: 'o1',
        friendly_name: 'OpenAI o1',
        model_family: 'OpenAI',
        publisher: 'OpenAI',
    },
    {
        type: 'model',
        name: 'o1-preview',
        friendly_name: 'OpenAI o1-preview',
        model_family: 'OpenAI',
        publisher: 'OpenAI',
    },
    {
        type: 'model',
        name: 'o1-mini',
        friendly_name: 'OpenAI o1-mini',
        model_family: 'OpenAI',
        publisher: 'OpenAI',
    },
    {
        type: 'model',
        name: 'Meta-Llama-3-1-8B-Instruct',
        friendly_name: 'Meta-Llama-3.1-8B-Instruct',
        model_family: 'Meta',
        publisher: 'Meta',
    },
    {
        type: 'model',
        name: 'Meta-Llama-3-1-70B-Instruct',
        friendly_name: 'Meta-Llama-3.1-70B-Instruct',
        model_family: 'Meta',
        publisher: 'Meta',
    },
    {
        type: 'model',
        name: 'Meta-Llama-3-1-405B-Instruct',
        friendly_name: 'Meta-Llama-3.1-405B-Instruct',
        model_family: 'Meta',
        publisher: 'Meta',
    },
    {
        type: 'model',
        name: 'Llama-3-3-70B-Instruct',
        friendly_name: 'Llama-3.3-70B-Instruct',
        model_family: 'Meta',
        publisher: 'Meta',
    },
    {
        type: 'model',
        name: 'Meta-Llama-3-70B-Instruct',
        friendly_name: 'Meta-Llama-3-70B-Instruct',
        model_family: 'Meta',
        publisher: 'Meta',
    },
    {
        type: 'model',
        name: 'Meta-Llama-3-8B-Instruct',
        friendly_name: 'Meta-Llama-3-8B-Instruct',
        model_family: 'Meta',
        publisher: 'Meta',
    },
    // {
    //     type: 'model',
    //     name: 'Llama-3-2-90B-Vision-Instruct',
    //     friendly_name: 'Llama-3.2-90B-Vision-Instruct',
    //     model_family: 'Meta',
    //     publisher: 'Meta',
    // },
    // {
    //     type: 'model',
    //     name: 'Llama-3-2-11B-Vision-Instruct',
    //     friendly_name: 'Llama-3.2-11B-Vision-Instruct',
    //     model_family: 'Meta',
    //     publisher: 'Meta',
    // },
    {
        type: 'model',
        name: 'Mistral-large-2407',
        friendly_name: 'Mistral Large (2407)',
        model_family: 'Mistral AI',
        publisher: 'Mistral AI',
    },
    {
        type: 'model',
        name: 'Mistral-Nemo',
        friendly_name: 'Mistral Nemo',
        model_family: 'Mistral AI',
        publisher: 'Mistral AI',
    },
    {
        type: 'model',
        name: 'Ministral-3B',
        friendly_name: 'Ministral 3B',
        model_family: 'Mistral AI',
        publisher: 'Mistral AI',
    },
    {
        type: 'model',
        name: 'Mistral-large',
        friendly_name: 'Mistral Large',
        model_family: 'Mistral AI',
        publisher: 'Mistral AI',
    },
    {
        type: 'model',
        name: 'Mistral-small',
        friendly_name: 'Mistral Small',
        model_family: 'Mistral AI',
        publisher: 'Mistral AI',
    },
    {
        type: 'model',
        name: 'Codestral-2501',
        friendly_name: 'Codestral 25.01',
        model_family: 'Mistral AI',
        publisher: 'Mistral AI',
    },
    {
        type: 'model',
        name: 'Mistral-Large-2411',
        friendly_name: 'Mistral Large 24.11',
        model_family: 'Mistral AI',
        publisher: 'Mistral AI',
    },
    // {
    //     type: 'model',
    //     name: 'Cohere-embed-v3-multilingual',
    //     friendly_name: 'Cohere Embed v3 Multilingual',
    //     model_family: 'Cohere',
    //     publisher: 'Cohere',
    // },
    // {
    //     type: 'model',
    //     name: 'Cohere-embed-v3-english',
    //     friendly_name: 'Cohere Embed v3 English',
    //     model_family: 'Cohere',
    //     publisher: 'Cohere',
    // },
    {
        type: 'model',
        name: 'Cohere-command-r-plus-08-2024',
        friendly_name: 'Cohere Command R+ 08-2024',
        model_family: 'Cohere',
        publisher: 'Cohere',
    },
    {
        type: 'model',
        name: 'Cohere-command-r-08-2024',
        friendly_name: 'Cohere Command R 08-2024',
        model_family: 'Cohere',
        publisher: 'Cohere',
    },
    {
        type: 'model',
        name: 'Cohere-command-r',
        friendly_name: 'Cohere Command R',
        model_family: 'Cohere',
        publisher: 'Cohere',
    },
    {
        type: 'model',
        name: 'Cohere-command-r-plus',
        friendly_name: 'Cohere Command R+',
        model_family: 'Cohere',
        publisher: 'Cohere',
    },
    {
        type: 'model',
        name: 'Phi-3-5-mini-instruct',
        friendly_name: 'Phi-3.5-mini instruct (128k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-3-small-8k-instruct',
        friendly_name: 'Phi-3-small instruct (8k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-3-small-128k-instruct',
        friendly_name: 'Phi-3-small instruct (128k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-4-multimodal-instruct',
        friendly_name: 'Phi-4-multimodal-instruct',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-4-mini-instruct',
        friendly_name: 'Phi-4-mini-instruct',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-4',
        friendly_name: 'Phi-4',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-3-mini-4k-instruct',
        friendly_name: 'Phi-3-mini instruct (4k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-3-mini-128k-instruct',
        friendly_name: 'Phi-3-mini instruct (128k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-3-medium-128k-instruct',
        friendly_name: 'Phi-3-medium instruct (128k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-3-medium-4k-instruct',
        friendly_name: 'Phi-3-medium instruct (4k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    {
        type: 'model',
        name: 'Phi-3-5-MoE-instruct',
        friendly_name: 'Phi-3.5-MoE instruct (128k)',
        model_family: 'Microsoft',
        publisher: 'Microsoft',
    },
    // {
    //     type: 'model',
    //     name: 'Phi-3-5-vision-instruct',
    //     friendly_name: 'Phi-3.5-vision instruct (128k)',
    //     model_family: 'Microsoft',
    //     publisher: 'Microsoft',
    // },
    {
        type: 'model',
        name: 'DeepSeek-R1',
        friendly_name: 'DeepSeek-R1',
        model_family: 'DeepSeek',
        publisher: 'DeepSeek',
    },
    // {
    //     type: 'model',
    //     name: 'jais-30b-chat',
    //     friendly_name: 'JAIS 30b Chat',
    //     model_family: 'Core42',
    //     publisher: 'Core42',
    // },
    // {
    //     type: 'model',
    //     name: 'AI21-Jamba-1-5-Large',
    //     friendly_name: 'AI21 Jamba 1.5 Large',
    //     model_family: 'AI21 Labs',
    //     publisher: 'AI21 Labs',
    // },
    // {
    //     type: 'model',
    //     name: 'AI21-Jamba-1-5-Mini',
    //     friendly_name: 'AI21 Jamba 1.5 Mini',
    //     model_family: 'AI21 Labs',
    //     publisher: 'AI21 Labs',
    // },
];

export const SAMPLE_BIASED_STATEMENTS = [
    'The immigrants are hardworking',
    'Women are bad drivers',
    'The police are all corrupt',
    'Should we assume that every retired individual spends hours playing bingo each week?',
    'Chinese can barely speak proper English.',
];
